export default {
  modalType: 'alert',
  isModalOpen: false,
  modalAlertingMessage: '',
  modalConfirmAction: false,
  showNationalSurveyPrompt: true,
  modalConfirmActionCallback: () => { },
};
